export default __webpack_public_path__ + "static/media/SIGUIENTE.9ff0e73d.png";